module.exports = __webpack_public_path__ + "media/banks/bank-bbt-5aab23a1.png";